<!-- Mobile backdrop -->
<div class="mobile-backdrop d-md-none" [class.show]="isMobileMenuOpen" (click)="onCloseMobileMenu()"></div>

<div class="main-container">
  <div class="mb-3 d-flex w-100">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs left-nav-bar col-md-2 display-set"
      [class.mobile-open]="isMobileMenuOpen">

      <!-- Mobile close button INSIDE the ul -->
      <button class="mobile-close d-md-none" (click)="onCloseMobileMenu()">
        <i class="bi bi-x-lg"></i>
      </button>

      <!-- All li elements INSIDE the ul -->
      <li class="me-3 nav-item" [ngbNavItem]="5">
        <a class="link" ngbNavLink [routerLink]="['/results', puid]" (click)="onCloseMobileMenu()">Dashboard</a>
        <ng-template ngbNavContent></ng-template>
      </li>

      <li class="me-3 nav-item" [ngbNavItem]="6">
        <a class="link" ngbNavLink [routerLink]="['/wishlist', puid]" (click)="onCloseMobileMenu()">University
          Shortlist</a>
        <ng-template ngbNavContent></ng-template>
      </li>

      <li class="me-3" [ngbNavItem]="1">
        <a class="link" ngbNavLink (click)="onCloseMobileMenu()">My Profile</a>
        <ng-template ngbNavContent>
          <app-student-admission-profile *ngIf="studentData" [admissionData]="studentData"
            [sectionCompletionData]="sectionCompletionData" (updateProfileSectionData)="getUpdateProfileData($event)">
          </app-student-admission-profile>
        </ng-template>
      </li>

      <li class="me-3" [ngbNavItem]="2">
        <a ngbNavLink class="disabled-tab" (click)="onCloseMobileMenu()">My Documents</a>
        <ng-template ngbNavContent>
          <app-student-admission-documents *ngIf="studentId && applicantId" [applicantId]="applicantId"
            [studentId]="studentId" [studentApplicantData]="studentData" [companyName]="companyName"
            (documentUpdatedData)="getDocumentUpdatedData($event)">
          </app-student-admission-documents>
        </ng-template>
      </li>

      <!-- <li class="me-3" [ngbNavItem]="4">
        <a class="link" ngbNavLink (click)="onCloseMobileMenu()">Payments <i class="bi bi-lock"></i></a>
        <ng-template ngbNavContent>
          <fa-payments *ngIf="applicantData" [applicantData]="applicantData">
          </fa-payments>
        </ng-template>
      </li> -->



      <li class="me-3" [ngbNavItem]="3">
        <a ngbNavLink class="disabled-tab" (click)="onCloseMobileMenu()">My Applications</a>
        <ng-template ngbNavContent>
          <fa-student-applications *ngIf="studentId && applicantId && applicantData" [applicantId]="applicantId"
            [studentId]="studentId" [admissionData]="studentData" [applicantData]="applicantData"
            (updateProfileSectionData)="getUpdateProfileData($event)">
          </fa-student-applications>
        </ng-template>
      </li>

    </ul> <!-- CLOSE ul tag here -->

    <main>
      <div [ngbNavOutlet]="nav" class="mt-4 p-4 mobile-css"></div>
    </main>
  </div>
</div>